module.exports = __webpack_public_path__ + "static/HTH2-121b0a56a6dd2b91833b9df21a08296d.png";